<template>
  <div v-if="!isEmpty" class="user-listing-detail">
    <div
      class="
        Head-div
        p-3
        d-flex
        justify-content-between
        align-items-center
        border-bottom
      "
    >
      <h4 class="mb-0">Patient Details</h4>
      <div class="cursor" @click.stop="$emit('close')">
        <crossSVG />
      </div>
    </div>
    <CCol sm="12" class="px-0 inner-scroller">
      <CCol sm="12" class="user-profile-info border-bottom">
        <div class="media justify-content-space-bet flex-dir-col">
          <div class="mobile-media d-flex">
            <image-view
              :src="
                patientInfo.userProfile.profile_image
                  ? patientInfo.userProfile.profile_image
                  : '/img/avatars/default-user.png'
              "
            ></image-view>
            <div
              class="
                media-body
                pl-4
                xs-mb-10
                d-flex
                list-flex-dir-col list-sm-box
              "
            >
              <div>
                <h3 class="mt-0 font-weight-normal">
                  {{ patientInfo.userProfile.full_name }}
                </h3>
                <p class="mb-1">
                  <span class="text-dark">Email :</span>
                  {{ patientInfo.patient.email }}
                </p>
                <p class="mb-1">
                  <span class="text-dark">Gender :</span>
                  {{ patientInfo.patient.gender }}
                </p>
                <p class="mb-1">
                  <span class="text-dark">Mobile :</span>
                  {{
                    patientInfo.patient.mobile
                      ? patientInfo.patient.mobile
                      : "&#8213;"
                  }}
                </p>
              </div>
              <!-- <div class="pl-3 mt-2">
                <h6>Roles</h6>
                <div class="d-flex">
                  <div
                    v-for="(role, i) in patientInfo.userProfile.roles"
                    :key="i"
                    class="pr-1"
                  >
                    <v-btn large class="mr-3 mb-2">{{ role }}</v-btn>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div>
            <v-btn  color="red" v-if="
                    permissions.includes('CAN_ACTIVE_DEACTIVE_USER') &&
                    !patientInfo.userProfile.is_deactivated"
                    @click="openDeactivateModal(patientInfo)">
                    Deactivate</v-btn>
            <v-btn color="green" 
                   v-if="
                    permissions.includes('CAN_ACTIVE_DEACTIVE_USER') &&
                    patientInfo.userProfile.is_deactivated"
                    @click="openActivateModal(patientInfo)">Activate</v-btn>
            <div class="mt-2">
              <span class="font-weight-bold">Referral Code:</span>
              {{
                patientInfo.userProfile &&
                patientInfo.userProfile.reference_code &&
                patientInfo.userProfile.reference_code.code
                  ? patientInfo.userProfile.reference_code.code
                  : "&#8213;"
              }}
            </div>
          </div>
        </div>
      </CCol>
      <!-- .... end user-profile-info ... -->
      <CCol sm="12" class="px-0">
        <!-- ...... Personal Details...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Personal Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol md="2" sm="6" class="d-flex">
                <p class="text-dark mb-0">Date of birth :</p>
                <p>
                  {{
                    patientInfo.patient.dob
                      ? dayJS(patientInfo.patient.dob).format(
                          formats.date_format
                        )
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol md="1" sm="6" class="d-flex">
                <p class="text-dark mb-0">Age :</p>
                <p>
                  {{
                    patientInfo.patient.age
                      ? patientInfo.patient.age
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol md="2" sm="6" class="d-flex">
                <p class="text-dark mb-0">Blood Group :</p>
                <p>
                  {{
                    patientInfo.patient.blood_group
                      ? patientInfo.patient.blood_group
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol md="3" sm="6" class="d-flex flex-div-width">
                <p class="text-dark mb-0">Languages :</p>
                <p>
                  {{
                    patientInfo.patient.known_languages
                      ? patientInfo.patient.known_languages.join(", ")
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol
                @click="
                  patientInfo.userProfile.national_identity_type
                    ? openModal(
                        patientInfo.userProfile.national_identity_certificate,
                        patientInfo.userProfile.national_identity_type
                      )
                    : null
                "
                sm="6"
                md="4"
                class="d-flex"
              >
                <p class="text-dark mb-0">Identity Type :</p>
                <div class="d-flex align-items-center">
                  <p class="mb-0">
                    {{
                      patientInfo.userProfile.national_identity_type
                        ? patientInfo.userProfile.national_identity_type
                        : "&#8213;"
                    }}
                  </p>
                  <div
                    class="file-attachment d-flex align-items-center ml-4"
                    v-if="patientInfo.userProfile.national_identity_type"
                  >
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        patientInfo.userProfile.national_identity_certificate
                          .split("/")
                          .pop()
                      }}
                    </p>
                  </div>
                </div>
              </CCol>
            </CRow>
            <!-- ............ -->
            <CRow>
              <CCol md="4" sm="6" class="d-flex">
                <p class="text-dark mb-0">
                  Birthmark / Personal Identification Mark, if any :
                </p>
                <p>
                  {{
                    patientInfo.userProfile.birthmark
                      ? patientInfo.userProfile.birthmark
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol md="2" sm="6" class="d-flex">
                <p class="text-dark mb-0">Occupation :</p>
                <p>
                  {{
                    patientInfo.userProfile.occupation
                      ? patientInfo.userProfile.occupation
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol md="3" sm="6" class="d-flex">
                <p class="text-dark mb-0">Designation :</p>
                <p>
                  {{
                    patientInfo.userProfile.designation
                      ? patientInfo.userProfile.designation
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3" class="d-flex flex-div-width">
                <p class="text-dark mb-0">Religion :</p>
                <p>
                  {{
                    patientInfo.userProfile.religion
                      ? patientInfo.userProfile.religion
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol
                sm="6"
                md="6"
                @click="
                  patientInfo.userProfile.financial_doc_url
                    ? openModal(
                        patientInfo.userProfile.financial_doc_url,
                        'APL/BPL Card'
                      )
                    : null
                "
              >
                <p class="text-dark mb-0">I am an APL/BPL Card holder :</p>
                <div class="d-flex align-items-center">
                  <div class="file-attachment d-flex align-items-center">
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        patientInfo.userProfile.financial_doc_url
                          ? patientInfo.userProfile.financial_doc_url
                              .split("/")
                              .pop()
                          : "&#8213;"
                      }}
                    </p>
                  </div>
                </div>
              </CCol>
              <CCol sm="6" md="6">
                <p class="text-dark mb-0">
                  After my Death I want to donate my organs :
                </p>
                <p>
                  {{
                    patientInfo.userProfile.donate_organs.length > 0
                      ? patientInfo.userProfile.donate_organs.join(", ")
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
            <!-- ............ -->
            <!-- ............ -->
            <CRow>
              <CCol sm="6" md="6">
                <p class="text-dark mb-0">
                  Relife member :
                </p>
                <p>
                  {{ patientInfo.userProfile.is_relife_member ? "Yes" : "No" }}
                </p>
              </CCol>
              <CCol
                sm="6"
                md="6"
                @click="
                  patientInfo.userProfile.euthanasia_affidavit
                    ? openModal(
                        patientInfo.userProfile.euthanasia_affidavit,
                        'Euthansia Affidavit'
                      )
                    : null
                "
              >
                <p class="text-dark mb-0">
                  At the end of life I want Passive Euthanasia :
                </p>
                <div class="d-flex align-items-center">
                  <div v-if ="patientInfo.userProfile.euthanasia_affidavit" class="file-attachment d-flex align-items-center">
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        patientInfo.userProfile.euthanasia_affidavit
                          ? patientInfo.userProfile.euthanasia_affidavit
                              .split("/")
                              .pop()
                          : "&#8213;"
                      }}
                    </p>
                  </div>
                </div>
              </CCol>
            </CRow>
            <!-- ............ -->
            <CRow>
              <CCol sm="12">
                <h6 class="mb-5 text-dark">Nominee Details</h6>
                <CCol sm="12">
                  <CRow>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">First Name :</p>
                      <p>
                        {{
                          patientInfo.userProfile.nominee_first_name
                            ? patientInfo.userProfile.nominee_first_name
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Last Name :</p>
                      <p>
                        {{
                          patientInfo.userProfile.nominee_last_name
                            ? patientInfo.userProfile.nominee_last_name
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Relationship :</p>
                      <p>
                        {{
                          patientInfo.userProfile.nominee_relation
                            ? patientInfo.userProfile.nominee_relation
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Mobile Number :</p>
                      <p>
                        {{
                          patientInfo.userProfile.nominee_mobile
                            ? patientInfo.userProfile.nominee_mobile
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                    <CCol sm="6" md="2" class="p-0">
                      <p class="text-dark mb-0">Email :</p>
                      <p>
                        {{
                          patientInfo.userProfile.nominee_email
                            ? patientInfo.userProfile.nominee_email
                            : "&#8213;"
                        }}
                      </p>
                    </CCol>
                  </CRow>
                </CCol>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- ...... end Personal Details...... -->
        <!-- ...... Address Info ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Address Info</h6>
          </CCol>
          <!-- ............ -->
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Current address :</p>
                <p v-if="patientInfo.patient.address.current_address">
                  {{
                    patientInfo.patient.address.current_address.address_line_two
                      ? patientInfo.patient.address.current_address
                          .address_line_two
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">More details :</p>
                <p v-if="patientInfo.patient.address.current_address">
                  {{
                    patientInfo.patient.address.current_address.address_line_one
                      ? patientInfo.patient.address.current_address
                          .address_line_one
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Permanent address same as current address :
                </p>
                <p>
                  {{
                    patientInfo.patient.address.is_same_as_current
                      ? patientInfo.patient.address.is_same_as_current
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Permant address :</p>
                <p v-if="patientInfo.patient.address.permanent_address">
                  {{
                    patientInfo.patient.address.permanent_address
                      .address_line_two
                      ? patientInfo.patient.address.permanent_address
                          .address_line_two
                      : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="4">
                <p class="text-dark mb-0">More details :</p>
                <p v-if="patientInfo.patient.address.permanent_address">
                  {{
                    patientInfo.patient.address.permanent_address
                      .address_line_one
                      ? patientInfo.patient.address.permanent_address
                          .address_line_one
                      : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- ...... end Address Info ...... -->
        <!-- ..... Dependent ....... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Dependent</h6>
          </CCol>
          <!-- ............ -->
          <CCol sm="12" v-if="patientInfo.userProfile.dependent_ids.length">
            <CCol
              v-for="(dependent, i) in patientInfo.userProfile.dependent_ids"
              :key="i"
              sm="12"
              class="border-bottom"
              :class="{
                'border-bottom': !(
                  i ===
                  patientInfo.userProfile.dependent_ids.length - 1
                ),
              }"
            >
              <CRow>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">First Name :</p>
                  <p>
                    {{
                      dependent.dependent_user.first_name
                        ? dependent.dependent_user.first_name
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Middle Name :</p>
                  <p>
                    {{
                      dependent.dependent_user.middle_name
                        ? dependent.dependent_user.middle_name
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Last Name :</p>
                  <p>
                    {{
                      dependent.dependent_user.last_name
                        ? dependent.dependent_user.last_name
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Gender :</p>
                  <p>
                    {{
                      dependent.dependent_user.gender
                        ? dependent.dependent_user.gender
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Relationship :</p>
                  <p>
                    {{
                      dependent.relation_to_parent_user
                        ? dependent.relation_to_parent_user
                        : "&#8213;"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Date of birth :</p>
                  {{
                    dependent.dependent_user.dob
                      ? dayJS(dependent.dependent_user.dob).format(
                          formats.date_format
                        )
                      : "&#8213;"
                  }}
                  <!-- <p>11 June 2009</p> -->
                </CCol>
              </CRow>
              <!-- ... -->
              <CRow>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Age :</p>
                  <p
                    v-if="
                      dependent &&
                      dependent.dependent_user &&
                      dependent.dependent_user.age > 0
                    "
                  >
                    {{
                      dependent.dependent_user.age
                        ? dependent.dependent_user.age
                        : "&#8213;"
                    }}
                  </p>
                  <p v-else>
                    {{
                      getAge(
                        dependent.dependent_user.dob
                          ? dependent.dependent_user.dob
                          : dependent.dependent_user.estimated_dob
                      )
                    }}
                    month
                  </p>
                </CCol>
                <CCol sm="6" md="2">
                  <p class="text-dark mb-0">Email :</p>
                  <p>{{ dependent.email ? dependent.email : "&#8213;" }}</p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Mobile Number :</p>
                  <p>{{ dependent.mobile ? dependent.mobile : "&#8213;" }}</p>
                </CCol>
              </CRow>
              <!-- ... -->
            </CCol>
          </CCol>
          <CCol sm="12" v-else>
            <div>No Data Found</div>
          </CCol>
        </CCol>
        <!-- ..... end Dependent ....... -->
        <!-- ... view more ... -->
        <CCol sm="12" class="p-0" v-if="showHideDetails">
          <!-- ...... Past Medical History ...... -->
          <CCol sm="12" class="p-0">
            <CCol sm="12" class="border-bottom">
              <h6 class="mb-0 text-dark">Past Medical History</h6>
            </CCol>
            <!-- ............ -->
            <CCol sm="12" class="border-bottom">
              <CCol sm="12" class="p-0">
                <h6 class="text-dark mb-0">Diseases/Events</h6>
              </CCol>
              <CCol sm="12" class="px-0">
                <div v-if="patientInfo.patient.medical_history.length">
                  <div
                    v-for="(medical_history, i) in patientInfo.patient
                      .medical_history"
                    :key="i"
                  >
                    <div
                      v-if="
                        medical_history.medical_type === 'disease' &&
                        medical_history.is_visible
                      "
                    >
                      <CRow>
                        <CCol sm="6" md="3">
                          <p class="text-dark mb-0">Disease :</p>
                          <p>
                            {{
                              medical_history.title
                                ? medical_history.title
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="4">
                          <p class="text-dark mb-0">Start Date :</p>
                          <p>
                            {{
                              medical_history.start_year
                                ? (medical_history.start_date
                                    ? `${medical_history.start_date}/`
                                    : "") +
                                  (medical_history.start_month
                                    ? `${medical_history.start_month}/`
                                    : "") +
                                  medical_history.start_year
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="3">
                          <p class="text-dark mb-0">Ongoing Diseases :</p>
                          <p>
                            {{ medical_history.present_event ? "Yes" : "No" }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="2">
                          <p class="text-dark mb-0">Last Date :</p>
                          <p>
                            {{
                              medical_history.end_year
                                ? (medical_history.end_date
                                    ? `${medical_history.end_date}/`
                                    : "") +
                                  (medical_history.end_month
                                    ? `${medical_history.end_month}/`
                                    : "") +
                                  medical_history.end_year
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                      </CRow>
                      <CRow>
                        <CCol sm="6" md="4">
                          <p class="text-dark mb-0">Remark :</p>
                          <p>
                            {{
                              medical_history.remark
                                ? medical_history.remark
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                      </CRow>
                      <hr />
                    </div>
                  </div>
                </div>
                <div v-else>No Data Found</div>
                <!-- ............ -->
                <CCol sm="12" class="p-0">
                  <h6 class="text-dark mb-0">Hospitalization / Surgery</h6>
                  <br />
                </CCol>
                <div v-if="patientInfo.userProfile.medical_history.length">
                  <div
                    v-for="(hospitalisation_history, i) in patientInfo
                      .userProfile.medical_history"
                    :key="i"
                  >
                    <div
                      v-if="
                        hospitalisation_history.medical_type === 'surgery' &&
                        hospitalisation_history.is_visible
                      "
                    >
                      <CRow>
                        <CCol sm="6" md="3">
                          <p class="text-dark mb-0">Diagnosis :</p>
                          <p>
                            {{
                              hospitalisation_history.diagnosis
                                ? hospitalisation_history.diagnosis
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="1">
                          <p class="text-dark mb-0">Year :</p>
                          <p>
                            {{
                              hospitalisation_history.start_year
                                ? hospitalisation_history.start_year
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="3">
                          <p class="text-dark mb-0">Hospital Name :</p>
                          <p>
                            {{
                              hospitalisation_history.hospital_name
                                ? hospitalisation_history.hospital_name
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="2">
                          <p class="text-dark mb-0">Doctor Name :</p>
                          <p>
                            {{
                              hospitalisation_history.doctor_name
                                ? hospitalisation_history.doctor_name
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                        <CCol sm="6" md="3">
                          <p class="text-dark mb-0">Remark :</p>
                          <p>
                            {{
                              hospitalisation_history.remark
                                ? hospitalisation_history.remark
                                : "&#8213;"
                            }}
                          </p>
                        </CCol>
                      </CRow>
                      <hr />
                    </div>
                  </div>
                </div>
                <div v-else>No Data Found</div>
                <!-- ............ -->
                <CCol sm="12" class="p-0">
                  <h6 class="text-dark mb-0">Allergy</h6>
                  <br />
                </CCol>
                <div v-if="patientInfo.userProfile.allergy.length">
                  <div
                    v-for="(allergy, i) in patientInfo.userProfile.allergy"
                    :key="i"
                  >
                    <CRow>
                      <CCol sm="6" md="3">
                        <p class="text-dark mb-0">Type :</p>
                        <p>{{ allergy.allergy_type }}</p>
                      </CCol>
                      <CCol sm="6" md="3">
                        <p class="text-dark mb-0">Allergy To :</p>
                        <p>{{ allergy.allergy_to }}</p>
                      </CCol>

                      <CCol sm="6" md="4">
                        <p class="text-dark mb-0">Reaction :</p>
                        <p>{{ allergy.reaction }}</p>
                      </CCol>
                    </CRow>
                    <hr />
                  </div>
                </div>
                <div v-else>No Data Found</div>
                <!-- ............ -->
              </CCol>
            </CCol>
            <!-- ............ -->
          </CCol>
          <!-- ...... end Past Medical History ...... -->
          <!-- ...... Life Style ...... -->
          <CCol sm="12" class="p-0">
            <CCol sm="12" class="border-bottom">
              <h6 class="mb-0 text-dark">Life Style</h6>
            </CCol>
            <CCol sm="12" class="border-bottom">
              <CCol sm="12" class="p-0">
                <h6 class="text-dark mb-0">Addiction</h6>
                <!-- <p>&#8213;</p> -->
              </CCol>
              <CCol sm="12" class="px-0">
                <CRow>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Smoking:</p>
                    <p>
                      {{
                        patientInfo.userProfile.smoking_habit
                          ? patientInfo.userProfile.smoking_habit
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Alcohol :</p>
                    <p>
                      {{
                        patientInfo.userProfile.liquor_habit
                          ? patientInfo.userProfile.liquor_habit
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Tobacco :</p>
                    <p>
                      {{
                        patientInfo.userProfile.tobacco_habit
                          ? patientInfo.userProfile.tobacco_habit
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Recreational Drugs :</p>
                    <p v-if="patientInfo.userProfile.on_recreational_drugs">
                      {{
                        patientInfo.userProfile.recreational_drugs
                          ? patientInfo.userProfile.recreational_drugs.join(
                              ", "
                            )
                          : "&#8213;"
                      }}
                      {{
                        patientInfo.userProfile.recreational_drugs.includes(
                          "Other"
                        )
                          ? patientInfo.userProfile.other_recreational_drugs
                            ? `(${patientInfo.userProfile.other_recreational_drugs})`
                            : "&#8213;"
                          : ""
                      }}
                    </p>
                  </CCol>
                </CRow>
                <!-- ............ -->
                <CRow>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Sexually Active :</p>
                    <p>
                      {{
                        patientInfo.userProfile.sexually_active ? "Yes" : "No"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Orientation :</p>
                    <p>
                      {{
                        patientInfo.userProfile.sexual_orientation
                          ? patientInfo.userProfile.sexual_orientation.join(
                              ", "
                            )
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Gym(hours per week) :</p>
                    <p>
                      {{
                        patientInfo.userProfile.exercise.find(
                          (el) => el.activity == "gym"
                        )
                          ? patientInfo.userProfile.exercise.find(
                              (el) => el.activity == "gym"
                            ).duration_per_week
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Yoga(hours per week) :</p>
                    <p>
                      {{
                        patientInfo.userProfile.exercise.find(
                          (el) => el.activity == "yoga"
                        )
                          ? patientInfo.userProfile.exercise.find(
                              (el) => el.activity == "yoga"
                            ).duration_per_week
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Walking(kilometers per week) :</p>
                    <p>
                      {{
                        patientInfo.userProfile.exercise.find(
                          (el) => el.activity == "walking"
                        )
                          ? patientInfo.userProfile.exercise.find(
                              (el) => el.activity == "walking"
                            ).duration_per_week
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Hazardous Chemical :</p>
                    <p>
                      {{
                        patientInfo.userProfile.hazardous_chemical
                          ? `Yes (${patientInfo.userProfile.hazardous_chemical_remarks})`
                          : "No"
                      }}
                    </p>
                  </CCol>
                </CRow>
                <!-- ............ -->
              </CCol>
            </CCol>
          </CCol>
          <!-- ...... end Life Style ...... -->
          <!-- ...... My Disability History ...... -->
          <CCol sm="12" class="p-0">
            <CCol sm="12" class="border-bottom">
              <h6 class="mb-0 text-dark">My Disability History</h6>
            </CCol>
            <CCol sm="12" class="border-bottom">
              <CRow>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Left Eye Sight :</p>
                  <p>
                    {{
                      patientInfo.userProfile.left_eye_sight
                        ? "Normal"
                        : "Reduced"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Right Eye Sight :</p>
                  <p>
                    {{
                      patientInfo.userProfile.right_eye_sight
                        ? "Normal"
                        : "Reduced"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Speech Impairment :</p>
                  <p>
                    {{
                      patientInfo.userProfile.speech_impairment ? "Yes" : "No"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Able To Bathe :</p>
                  <p>
                    {{ patientInfo.userProfile.able_to_bath ? "Yes" : "No" }}
                  </p>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Left Ear Hearing :</p>
                  <p>
                    {{
                      patientInfo.userProfile.left_ear_hearing
                        ? "Normal"
                        : "Reduced"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Right Ear Hearing :</p>
                  <p>
                    {{
                      patientInfo.userProfile.right_ear_hearing
                        ? "Normal"
                        : "Reduced"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Physical Mobility :</p>
                  <p>
                    {{
                      patientInfo.userProfile.physical_mobility
                        ? "Normal"
                        : "Reduced"
                    }}
                  </p>
                </CCol>
                <CCol sm="6" md="3">
                  <p class="text-dark mb-0">Able To Eat :</p>
                  <p>
                    {{ patientInfo.userProfile.able_to_eat ? "Yes" : "No" }}
                  </p>
                </CCol>
                <CCol
                  sm="6"
                  md="3"
                  @click="
                    patientInfo.userProfile.disability_certificate
                      ? openModal(
                          patientInfo.userProfile.disability_certificate,
                          'Euthansia Affidavit'
                        )
                      : null
                  "
                >
                  <p class="text-dark mb-0">
                    Received Disability Certificate :
                  </p>
                  <div class="file-attachment d-flex align-items-center">
                    <fileSVG />
                    <p class="ml-2 mb-0 cursor">
                      {{
                        patientInfo.userProfile.disability_certificate
                          ? patientInfo.userProfile.disability_certificate
                              .split("/")
                              .pop()
                          : "&#8213;"
                      }}
                    </p>
                  </div>
                </CCol>
              </CRow>
            </CCol>
          </CCol>
          <!-- ...... end My Disability History ...... -->
          <!-- ...... Family Medical History ...... -->
          <CCol sm="12" class="p-0">
            <CCol sm="12" class="border-bottom">
              <h6 class="mb-0 text-dark">Family Medical History</h6>
            </CCol>
            <CCol sm="12" v-if="patientInfo.userProfile.family_history.length">
              <CCol
                v-for="(familyHistory, i) in patientInfo.userProfile
                  .family_history"
                :key="i"
                sm="12"
                class="border-bottom"
              >
                <CRow>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">First Name :</p>
                    <p>
                      {{ familyHistory.name ? familyHistory.name : "&#8213;" }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Relationship :</p>
                    <p>
                      {{
                        familyHistory.relation
                          ? familyHistory.relation
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Any Long standing Disease :</p>
                    <p>
                      {{
                        familyHistory.disease
                          ? familyHistory.disease
                              .map((el) => el.name)
                              .join(", ")
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                  <CCol sm="6" md="3">
                    <p class="text-dark mb-0">Age When Decease :</p>
                    <p>
                      {{
                        familyHistory.age_when_deceased
                          ? familyHistory.age_when_deceased
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6" md="5">
                    <p class="text-dark mb-0">Cause Of Death :</p>
                    <p>
                      {{
                        familyHistory.cause_of_death
                          ? familyHistory.cause_of_death
                          : "&#8213;"
                      }}
                    </p>
                  </CCol>
                </CRow>
              </CCol>
            </CCol>
            <CCol sm="12" v-else>
              <div>No Data Found</div>
            </CCol>
          </CCol>
          <!-- ...... end Family Medical History ...... -->
        </CCol>
        <!-- ... end view more ... -->
        <CCol sm="12" class="d-flex justify-content-end">
          <v-btn
            color="green"
            text
            @click="showHideDetails = true"
            v-if="!showHideDetails"
            >View More</v-btn
          >
          <v-btn
            color="green"
            text
            @click="showHideDetails = false"
            v-if="showHideDetails"
            >View Less</v-btn
          >
        </CCol>
      </CCol>
    </CCol>

    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
    <v-dialog
      v-if="giveReason"
      v-model="giveReason"
      width="500"
      persistent
      id="view-box"
    >
      <give-reason
        :is-required="reasonRequired"
        @close="giveReason = false"
        @submit="submitUserStatus"
      />
    </v-dialog>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
import { mapGetters } from "vuex";
const LightBoxNew = () => import("@/components/lightBoxNew.vue");
const loader = () => import("@/components/loader.vue");
const imagePreview = () => import("@/components/modals/imagePreview.vue");
import "@/assets/scss/_userDetails.scss";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
export default {
  props: ["userId"],
  data() {
    return {
      showHideDetails: false,
      // user: {},
      giveReason: false,
      reasonRequired: false,
      patientInfo: {},
      statusUserId: "",
      isEmpty: true,
      dayJS,
      formats,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
    };
  },
  components: {
    "light-box-new": LightBoxNew,
    "image-view": Image,
    "image-preview": imagePreview,
    ...pickSvg("crossSVG", "fileSVG"),
    "give-reason": () => import("@/components/modals/giveReason"),
    loader,
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },

  mounted() {
    this.getPatientDetails();
  },
  methods: {
    openDeactivateModal(patientInfo) {
      this.statusUserId = patientInfo.userProfile.id;
      this.reasonRequired = true;
      this.statusActionFor = "deactivate";
      this.giveReason = true;
    },
    openActivateModal(patientInfo) {
      this.statusUserId = patientInfo.userProfile.id;
      this.reasonRequired = false;
      this.statusActionFor = "activate";
      this.giveReason = true;
    },
    getAge(age) {
      if (age) {
        let estimated_dob = this.dayJS().diff(age, "months");
        return (age = estimated_dob);
      }
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    getPatientDetails() {
      this.$store.commit("general/setLoader", true);
      let role = "patient";
      let url = `${config.BASE_URL}api/v2/admin/users/${this.userId}/profile?role=${role}`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.$store.commit("general/setLoader", false);
          this.patientInfo = response && response.body && response.body.data;
          this.isEmpty = false;
        } else {
          this.$store.commit("general/setLoader", false);
          this.isEmpty = true;
        }
      });
    },
    submitUserStatus(reason) {
      this.giveReason = false;
      let url = `${config.BASE_URL}api/v2/admin/users/deactivate`;
      if (this.statusActionFor == "activate") {
        url = `${config.BASE_URL}api/v2/admin/users/activate`;
      }
      this.$http
        .post(url, { reason: reason, id: this.statusUserId })
        .then((response) => {
          this.getPatientDetails();
          this.$swal(response.body.message);
        });
      // console.log("statusUserId", this.statusUserId);
      // console.log("statusActionFor", this.statusActionFor);
      // console.log("reasonRequired", this.reasonRequired);
      // console.log("reason", reason);
    },
  },
};
</script>